import { render, staticRenderFns } from "./LancamentoFrequenciaLotePage.vue?vue&type=template&id=280b67ff&scoped=true"
import script from "./LancamentoFrequenciaLotePage.vue?vue&type=script&lang=js"
export * from "./LancamentoFrequenciaLotePage.vue?vue&type=script&lang=js"
import style0 from "./LancamentoFrequenciaLotePage.vue?vue&type=style&index=0&id=280b67ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b67ff",
  null
  
)

export default component.exports